import React from 'react';
import style from './schema-layout.module.scss';
import EmptyIcon from '../../../../../../../assets/svg/solo-chat/empty.svg';

type Props = {
	type: 'entity' | 'intent';
};

export function EmptyState(props: Props) {
	return (
		<div className={style.empty}>
			<img src={EmptyIcon} alt="no-entities" />
			<p>You've yet to add any {props.type}. Please include a new one.</p>
		</div>
	);
}
